/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index pagination to autogenerate all the components and extensions
 * Used by "preparePaginations"
 */

import Pagination from './pagination/Pagination'
export * from './pagination/Pagination'
export default Pagination
